'use strict';

cartService.$inject = ["$rootScope", "api", "common", "Cart", "CartDraft", "AddedToCartInfo", "$http", "$localStorage", "ProductTypes", "OrderConfirmation", "ProductSet", "CartProduct", "Analytics", "$state", "Wholesaler"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartService = cartService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartService($rootScope, api, common, Cart, CartDraft, AddedToCartInfo, $http, $localStorage, ProductTypes, OrderConfirmation, ProductSet, CartProduct, Analytics, $state, Wholesaler) {

    //added products for analytics
    var addedProducts = [];

    return {
        getFromServer: getFromServer,
        getFromServerCheckoutCart: getFromServerCheckoutCart,
        addProduct: addProduct,
        removeProducts: removeProducts,
        changeQuantity: changeQuantity,
        checkout: checkout,
        createOrders: createOrders,
        clear: clear,
        deactivateMessage: deactivateMessage,
        getAddedToCartInfo: getAddedToCartInfo,
        quickAddProducts: quickAddProducts,
        updateCart: updateCart,
        updateCartOverview: updateCartOverview,
        getAddedProducts: getAddedProducts,
        addProductToAddedProductsList: addProductToAddedProductsList,
        addProductToCartAnalytics: addProductToCartAnalytics,
        setAddedProducts: setAddedProducts,
        reOrderProducts: reOrderProducts,
        getWholesalers: getWholesalers,
        removeSellerFromCart: removeSellerFromCart,
        getCustomerAccounts: getCustomerAccounts
    };

    function getCustomerAccounts() {
        return api.getCustomerAccounts.get().$promise.then(function (resource) {
            return resource;
        });
    }

    function setAddedProducts(products) {
        addedProducts = products;
    }

    function getAddedProducts() {
        return addedProducts;
    }

    function addProductToAddedProductsList(product) {
        if (!addedProducts.includes(product)) {
            addedProducts.push(product);
        }
    }

    function getFromServer() {
        return api.cart.get().$promise.then(function (resource) {
            var cart = Cart.create(resource);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        }).catch(function () {
            $rootScope.isShoppingCartInvalid = true;
        });
    }

    function getFromServerCheckoutCart() {
        return api.checkoutCart.get().$promise.then(function (resource) {
            var cart = Cart.create(resource);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        }).catch(function () {
            $rootScope.isShoppingCartInvalid = true;
        });
    }

    function getAddedToCartInfo(id) {
        return api.getAddedToCartInfo.get({
            id: id
        }).$promise.then(function (resource) {
            return AddedToCartInfo.create(resource);
        });
    }

    function addProduct(product) {
        var apiCall = null;
        var data = null;

        if (product.type === ProductTypes.single.clientValue) {
            apiCall = api.setProductQuantity;
            data = [{
                id: product.id,
                quantity: product.quantity
            }];
        } else if (product.type === ProductTypes.pack.clientValue) {
            apiCall = api.setProductQuantity;
            data = [{
                id: product.id,
                quantity: product.quantity
            }];
        } else if (product.type === ProductTypes.panacee.clientValue) {
            apiCall = api.setProductQuantity;
            data = _lodash2.default.map(product.included_products, function (p) {
                return {
                    id: p.id,
                    quantity: p.quantity
                };
            });
        } else {
            throw 'A product of type ' + product.type + ' cannot be used as argument of the addProduct method';
        }

        return apiCall.execute(data).$promise.then(function (data) {
            return data;
        });
    }

    function removeSellerFromCart(sellerBaseCodeId) {
        return api.removeSellerFromCart.execute(sellerBaseCodeId).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    function removeProducts(products) {

        products.forEach(function (product) {
            Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '');
            Analytics.trackCart('remove', product.displayName);
            Analytics.trackEvent('Product', 'removedFromCart', product.displayName);
            common.log.info('Analysis: product removed', product.name);
        });

        products = _lodash2.default.map(products, function (p) {
            return {
                id: p.id,
                quantity: 0
            };
        });
        products = _lodash2.default.map(products, function (o) {
            return ProductSet.create(o);
        });

        return api.quickAddProducts.execute(products).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    /* Update the cart for the shoppingcart pages */
    function updateCart(products) {

        products = products.filter(function (product) {
            return product.type !== 'panacee';
        });

        return api.quickAddProducts.execute(products).$promise.then(function (cart) {
            cart = Cart.create(cart);
            $localStorage.cart = cart;
            $rootScope.isShoppingCartEmpty = cart.isEmpty;
            return cart;
        });
    }

    /* Update the cart for the product overview and detail pages */
    function updateCartOverview(products) {

        var apiCall = api.setProductQuantity;
        products = products.filter(function (product) {
            return product.type !== 'panacee';
        });

        products = _lodash2.default.map(products, function (o) {
            return ProductSet.create(o);
        });

        return apiCall.execute(products).$promise.then(function (cart) {
            return _lodash2.default.map(cart, function (o) {
                return CartProduct.create(o);
            });
        });
    }

    function changeQuantity(cart, productId, quantity) {
        cart.changeQuantity(productId, quantity);
        $localStorage.cart = cart;
        $rootScope.isShoppingCartEmpty = cart.isEmpty;
    }

    function checkout() {
        return api.checkout.execute().$promise.then(function (resource) {
            return Cart.create(resource);
        });
    }

    function createOrders(isSpecial, selectedWholeSaler, selectedCustomerAccount) {
        var selectedWholeSalerId = selectedWholeSaler ? selectedWholeSaler.id : null;
        var selectedCustomerAccountNumber = selectedCustomerAccount ? selectedCustomerAccount.number : null;
        return api.createOrders.execute({
            isSpecial: isSpecial,
            wholeSalerId: selectedWholeSalerId,
            customerAccountNumber: selectedCustomerAccountNumber
        }).$promise.then(function (orders) {
            return _lodash2.default.map(orders, function (o) {
                return OrderConfirmation.create(o);
            });
        });
    }

    function clear() {
        return api.clearCart.execute().$promise.then(function () {
            $localStorage.cart = null;
            $rootScope.isShoppingCartEmpty = true;
        });
    }

    function deactivateMessage(id) {
        return api.deactivateCartMessage.deactivate({
            messageId: id
        }).$promise.then(function (resource) {
            return resource;
        });
    }

    function quickAddProducts(products) {
        return api.quickAddProducts.execute(products).$promise.then(function (resource) {
            return resource;
        });
    }

    /* google analytics when product clicked */
    function addProductToCartAnalytics() {
        if (addedProducts.length > 0) {
            addedProducts.forEach(function (product) {
                if (product.quantity === 0) {
                    Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId,
                        location: $state.current.name
                    });
                    Analytics.trackCart('remove', product.displayName);
                    Analytics.trackEvent('Product', 'removedFromCart', product.displayName);
                    common.log.info('Analysis: product removed', product.name);
                } else {
                    Analytics.addProduct(product.id, product.displayName, product.productTypeCode, product.sellerName, '', product.totalPriceWithDiscount, product.quantity, '', '', {
                        sellerId: product.sellerId,
                        sellerName: product.sellerName,
                        discountId: product.discountId,
                        location: $state.current.name
                    });
                    Analytics.trackCart('add', product.displayName);
                    Analytics.trackEvent('Product', 'addedToCart', product.displayName);
                    common.log.info('Analysis: product added', product.name);
                }
            });
        }
    }

    function reOrderProducts(id) {
        return api.reOrderProducts.execute({
            id: id
        }).$promise.then(function (resource) {
            return resource;
        });
    }

    function getWholesalers() {
        return api.wholesalers.get().$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (o) {
                return Wholesaler.create(o);
            });
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/cartService.js
// module id = 803
// module chunks = 0